import { render, staticRenderFns } from "./AccepterPasswordReconfig.vue?vue&type=template&id=b358223a&"
import script from "./AccepterPasswordReconfig.vue?vue&type=script&lang=ts&"
export * from "./AccepterPasswordReconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports